export const getLastPageOffset = (total, limit) => (total === 0 ? 0 : (Math.ceil(total / limit) - 1) * limit);
export const hasMore = ({limit, offset, totalResults} = {}) => offset + limit < totalResults;
